import Api from "../utils/api";

export const TOKEN_KEY = "borralo_token";
export const USER_KEY = "borralo_user";

export async function login(form) {
  const session = await Api.createResponse("app/auth/login", form);
  const token = session?.user?.token || session?.token || "";
  const userData = session?.user?.user || session?.user || session;

  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
  }

  return session;
}

export async function logout() {
  removeSession();
}

export function removeSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  window.location.replace(process.env.REACT_APP_BASENAME || "/");
}

export async function getProfile() {
  return await Api.createResponse("app/auth/get-user");
}

export async function recover(form) {
  return await Api.createResponse("app/auth/recover", form);
}

export async function checkCode(form) {
  return await Api.createResponse("app/auth/check-code", form);
}

export async function resetPassword(form) {
  return await Api.createResponse("app/auth/reset", form);
}

export async function getDocumentTypes(params = {}) {
  return await Api.createResponse("app/auth/document-types", params);
}

export async function getCities(params = {}) {
  return await Api.createResponse("app/auth/cities", params);
}

export async function saveProfile(form) {
  return await Api.createResponse("app/auth/save-profile", form);
}

const AuthService = {
  login,
  logout,
  removeSession,
  getProfile,
  recover,
  checkCode,
  resetPassword,
  reset: resetPassword,
  getDocumentTypes,
  getCities,
  saveProfile,
};

export default AuthService;
